import {
  CLEAR_DOMESTICOS_ACTION,
  FETCH_DOMESTICOS,
  FETCH_DOMESTICO_INFO,
  SEND_DOMESTICO,
  SEND_CAPTURES,
} from './actions.type';

import {
  SET_ERROR,
  CLEAR_DOMESTICOS,
  FETCHED_DOMESTICOS,
  FETCHING_DOMESTICOS,
  CLEAR_DOMESTICO_INFO,
  SET_DOMESTICO,
  FETCHING_DOMESTICO,
  FETCHED_DOMESTICO,
  SUBMITED_DOMESTICO,
  SUBMIT_DOMESTICO_ERROR,
  RESET_DOMESTICO_SUBMIT,
  SUBMIT_CAPTURES_ERROR,
  SUBMITTED_CAPTURES,
  CLEAR_CAPTURES,
  CLEAR_ALERT_DIALOG,
  RESET_DOMESTICO_PROCESSING,
  STARTED_DOMESTICO_PROCESSING,
  SET_DOMESTICO_CREDENTIAL,
  GENERATE_CREDENTIAL,
  CLEAR_DOMESTICO_CREDENCIAL,
} from './mutations.type';
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  loading_domesticos: false,
  processing_domestico: false,
  loading_domestico: false,
};

const getters = {
  is_loading() {
    return state.loading_domestico;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
  domestico_processing() {
    return state.processing_domestico;
  },
};

const actions = {
  [FETCH_DOMESTICO_INFO](context, domesticoId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_DOMESTICO);
      const url = `domesticos/${domesticoId}`;
      ApiService.query(url)
        .then(({ data }) => {
          context.commit(FETCHED_DOMESTICO);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_DOMESTICO);
        });
    });
  },
};

const mutations = {
  [FETCHING_DOMESTICO](state) {
    state.loading_domestico = true;
  },
  [FETCHED_DOMESTICO](state) {
    state.loading_domestico = false;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
